/** 孩子切换按钮：多个孩子时点开下拉菜单（当前孩子存在 localStorage） */
import { Check, ChevronDown } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { setSelectedChild, useChildren, useCurrentChild } from "../core/session";
import { Avatar } from "./layout";

export function ChildSwitcher({ large }: { /** 首页样式（带头像，48 高）；否则为 36 高的小胶囊 */ large?: boolean }) {
  const children = useChildren();
  const current = useCurrentChild();
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);
  const multi = children.length > 1;
  const name = current?.name ?? "还没有孩子";

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (!box.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="kp-switcher" ref={box}>
      <button type="button" className={`kp-switcher-btn ${large ? "is-large" : ""}`} disabled={!multi} aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(!open)}>
        {large && <Avatar name={name} size={36} />}
        <span>{name}</span>
        {multi && <ChevronDown size={large ? 15 : 13} strokeWidth={3} />}
      </button>
      {open && (
        <div className="kp-menu" role="menu">
          {children.map((c) => (
            <button
              key={c.id}
              type="button"
              role="menuitemradio"
              aria-checked={c.id === current?.id}
              onClick={() => {
                setSelectedChild(c.id);
                setOpen(false);
              }}
            >
              <Avatar name={c.name} size={26} />
              <span>{c.name}</span>
              {c.id === current?.id && <Check size={16} strokeWidth={3} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
